@if (
selectedUtility
) {
<app-utility-details (close)="selectedUtility=undefined" [utilityId]="selectedUtility.id!">
</app-utility-details>
}

<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
      <app-search class="pe-2" placeholder="{{ 'SETTINGS_SEARCHBYNAME' | translate }}"
        (searchChange)="searchChange($event)">
      </app-search>
      <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
      <app-status class="pe-2" [statuses]="utilityStatuses" (close)="onStatusOption($event)"></app-status>
      <app-country-filter class="pe-2" [useTranslate]="false" [statuses]="utilityCountries"
        (close)="onCountryOption($event)"></app-country-filter>

      <div class="datepicker-container-wrapper position-relative">
        <div class="button-wrapper">
          <div class="button">
            <img alt="Date" src="assets/core/table-button/date.svg" />
            <div class="button-text" (click)="toggleModal()"
              [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
              <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                {{ selectedDate }}
              </ng-container>
              <ng-template #noDateSelected>
                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
              </ng-template>
            </div>
            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
              (click)="clearDates()" />
          </div>
        </div>
        @if (isDatepickerOpen) {
        <div class="overlay" (click)="toggleModal()"></div>
        <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
          [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
        }
      </div>
    </div>
    <div class="row g-0 m-0 pt-3 gap-3 p-4 ps-5 pe-5">
      <div *ngFor="let row of reminderData; let i = index"
        class="row g-0 p-0 d-flex justify-content-between member-info p-3">
        <div class="col d-flex p-0 justify-content-start" (click)="handleRowClickUtility(row)">
          <div class="col ps-3 pe-3">
            <div>
              <span class="item-title">{{ row.name }}</span>
            </div>
            <div class="text bolded">
              <span>{{ row.acronym}}</span>
              <svg-icon alt="Dot Icon" src="assets/settings/dot.svg" class="pe-2 ps-2"></svg-icon>
              <span>{{ row.country }}</span>
              <svg-icon alt="Dot Icon" src="assets/settings/dot.svg" class="pe-2 ps-2"></svg-icon>
              <span>{{ row.websiteAddress }}</span>
              <svg-icon alt="Dot Icon" src="assets/settings/dot.svg" class="pe-2 ps-2"></svg-icon>
              <span>{{ row.contactPersonPhoneNumber }}</span>
              <svg-icon alt="Dot Icon" src="assets/settings/dot.svg" class="pe-2 ps-2"></svg-icon>
              <span>{{ row.creationDate | date: "dd MMM yyyy, h:mm a" }}</span>
            </div>
          </div>
        </div>
        <div class="col-auto p-0 subtitle d-flex justify-content-end align-items-center text">
          <span class="status" [ngClass]="{
            'active': row.status === UtilityStatus.Active, 
            'inactive': row.status === UtilityStatus.Inactive,
            'pending': row.status === UtilityStatus.Pending
            }">
            {{ row.status === UtilityStatus.Active ? 'Active' : row.status === UtilityStatus.Inactive ? 'Inactive' :
            'Pending' }}
          </span>
          <svg-icon alt="More" class="more-icon ps-1" src="assets/settings/more-icon.svg"
            (click)="setActiveRow(i)"></svg-icon>
          <!-- Dropdown -->
          <div *ngIf="activeRow === i" class="positioning">
            <div class="overlay-light" (click)="setActiveRow(null)"></div>
            <div class="dropdown-button p-2">
              <div class="dropdown-button-menu p-0 m-0">
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="editUtility(row.id!)">
                  <svg-icon alt="Edit" src="assets/device/edit.svg"></svg-icon>
                  <span class="ps-2 item-title">{{'EDIT_UTILITY' | translate}}</span>
                </div>
                @if (row.status == UtilityStatus.Active)
                {
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="updateStatus(row.id!, UtilityStatus.Inactive)">
                  <svg-icon alt="Deactivate" src="assets/settings/deactivate.svg"></svg-icon>
                  <span class="ps-2 item-title">{{
                    "DEACTIVATE" | translate
                    }}</span>
                </div>
                }
                @if (row.status == UtilityStatus.Inactive)
                {
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="updateStatus(row.id!, UtilityStatus.Active)">
                  <svg-icon alt="Activate" class="pb-1" src="assets/settings/activate.svg"></svg-icon>
                  <span class="ps-2 item-title">{{
                    "ACTIVATE" | translate
                    }}</span>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfReminders" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)">
    </app-pagination>
  </div>
</div>